<div class="loading-overlay" *ngIf="isLoading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="parametrages-page-container">
  <div class="parametrages-content-wrapper">

      <div class="param-toggle-bar mb-6">
        <button
          type="button"
          class="param-toggle-card"
          [ngClass]="{ 'active': selectedParamFilter === 'global' }"
          (click)="setParamFilter('global')">
          <span class="material-symbols-outlined">tune</span>
          <div class="param-toggle-content">
            <div class="param-toggle-title">Paramètres globaux</div>
            <div class="param-toggle-count">{{ getFilteredParametres('global').length }}</div>
          </div>
        </button>

        <button
          type="button"
          class="param-toggle-card"
          [ngClass]="{ 'active': selectedParamFilter === 'pre' }"
          (click)="setParamFilter('pre')">
          <span class="material-symbols-outlined">settings_suggest</span>
          <div class="param-toggle-content">
            <div class="param-toggle-title">Pré-paramétrage</div>
            <div class="param-toggle-count">{{ getFilteredParametres('pre').length }}</div>
          </div>
        </button>

        <button
          type="button"
          class="param-toggle-card"
          [ngClass]="{ 'active': selectedParamFilter === 'alert' }"
          (click)="setParamFilter('alert')">
          <span class="material-symbols-outlined">notifications_active</span>
          <div class="param-toggle-content">
            <div class="param-toggle-title">Alerte</div>
            <div class="param-toggle-count">{{ getFilteredParametres('alert').length }}</div>
          </div>
        </button>
      </div>

      <div class="parametrages-table-container">
        <div class="overflow-x-auto">
          <table class="parametrages-table">
            <thead class="parametrages-table-header">
              <tr>
                <th class="text-center" style="width: 60px;">
                  <button type="button" 
                          class="sort-header-btn" 
                          (click)="toggleSort()"
                          title="Trier par numéro">
                    <span>#</span>
                    <span class="material-symbols-outlined sort-icon" [ngClass]="{'sort-asc': sortOrder === 'asc', 'sort-desc': sortOrder === 'desc'}">
                      {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </span>
                  </button>
                </th>
                <th class="text-left" style="width: auto; min-width: 300px;">Paramètre</th>
                <th class="text-center" style="width: 220px;">Valeur</th>
              </tr>
            </thead>
            <tbody class="bg-white">
            <ng-container *ngIf="selectedParamFilter === 'global'">
              <tr *ngFor="let p of getFilteredParametres('global')" class="parametrages-table-row">
                <td class="parametrages-table-cell font-semibold text-gray-600">{{ p.number }}</td>
                <td class="parametrages-table-cell font-medium text-gray-800">{{ p.name }}</td>
                <td class="parametrages-table-cell">
                  <div [ngSwitch]="p.number" class="flex justify-center">
                    <div class="w-full">
                      <select *ngSwitchCase="3" 
                              class="param-select" 
                              [(ngModel)]="p.value">
                        <option value="" disabled>Choisir...</option>
                        <option value="Oui">Oui</option>
                        <option value="Non">Non</option>
                      </select>
                      <div *ngSwitchCase="4" class="tags-input-container">
                        <div class="tags-input-wrapper">
                          <span *ngFor="let tag of fieldTags[p.number]; let i = index" class="tag-inline">
                            {{ tag }}
                            <button type="button" class="tag-remove-inline" (click)="removeTag(i, p.number)">×</button>
                          </span>
                          <input type="text" 
                                 class="tags-input-inline" 
                                 [(ngModel)]="fieldInputs[p.number]"
                                 (input)="onFieldInput($event, p.number)"
                                 (keydown)="onFieldKeyDown($event, p.number)"
                                 placeholder="Numéro + Entrée" />
                        </div>
                      </div>
                      <div *ngSwitchCase="5" class="tags-input-container">
                        <div class="tags-input-wrapper">
                          <span *ngFor="let tag of fieldTags[p.number]; let i = index" class="tag-inline">
                            {{ tag }}
                            <button type="button" class="tag-remove-inline" (click)="removeTag(i, p.number)">×</button>
                          </span>
                          <input type="text" 
                                 class="tags-input-inline" 
                                 [(ngModel)]="fieldInputs[p.number]"
                                 (input)="onFieldInput($event, p.number)"
                                 (keydown)="onFieldKeyDown($event, p.number)"
                                 placeholder="Numéro + Entrée" />
                        </div>
                      </div>
                      <div *ngSwitchCase="6" class="tags-input-container">
                        <div class="tags-input-wrapper">
                          <span *ngFor="let tag of fieldTags[p.number]; let i = index" class="tag-inline">
                            {{ tag }}
                            <button type="button" class="tag-remove-inline" (click)="removeTag(i, p.number)">×</button>
                          </span>
                          <input type="text" 
                                 class="tags-input-inline" 
                                 [(ngModel)]="fieldInputs[p.number]"
                                 (input)="onFieldInput($event, p.number)"
                                 (keydown)="onFieldKeyDown($event, p.number)"
                                 placeholder="Numéro + Entrée" />
                        </div>
                      </div>
                      <select *ngSwitchCase="7" 
                              class="param-select" 
                              [(ngModel)]="p.value">
                        <option value="" disabled>Choisir...</option>
                        <option value="Actif">Actif</option>
                        <option value="Désactif">Désactif</option>
                      </select>
                      <div *ngSwitchCase="8" class="tags-input-container">
                        <div class="tags-input-wrapper">
                          <span *ngFor="let tag of fieldTags[p.number]; let i = index" class="tag-inline">
                            {{ tag }}
                            <button type="button" class="tag-remove-inline" (click)="removeTag(i, p.number)">×</button>
                          </span>
                          <input type="text" 
                                 class="tags-input-inline" 
                                 [(ngModel)]="fieldInputs[p.number]"
                                 (input)="onFieldInput($event, p.number)"
                                 (keydown)="onFieldKeyDown($event, p.number)"
                                 placeholder="0-59 + Entrée" />
                        </div>
                      </div>
                      <input *ngSwitchDefault 
                             type="text" 
                             class="param-input" 
                             [(ngModel)]="p.value"
                             placeholder="Valeur..." />
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
            
            <ng-container *ngIf="selectedParamFilter === 'pre'">
              <tr *ngFor="let p of getFilteredParametres('pre')" class="parametrages-table-row">
                <td class="parametrages-table-cell font-semibold text-gray-600">{{ p.number }}</td>
                <td class="parametrages-table-cell font-medium text-gray-800">{{ p.name }}</td>
                <td class="parametrages-table-cell">
                  <div [ngSwitch]="p.number" class="flex justify-center">
                    <div class="w-full" style="max-width: 200px; min-width: 180px;">
                      <input *ngSwitchCase="1" 
                             type="time" 
                             class="param-input" 
                             [(ngModel)]="p.value"
                             placeholder="HH:MM" />
                      <input *ngSwitchCase="2" 
                             type="time" 
                             class="param-input" 
                             [(ngModel)]="p.value"
                             placeholder="HH:MM" />
                      <input *ngSwitchCase="9" 
                             type="text" 
                             class="param-input" 
                             [(ngModel)]="p.value"
                             placeholder="Valeur..." />
                      <input *ngSwitchCase="10" 
                             type="time" 
                             class="param-input" 
                             [(ngModel)]="p.value"
                             placeholder="HH:MM" />
                      <input *ngSwitchCase="11" 
                             type="time" 
                             class="param-input" 
                             [(ngModel)]="p.value"
                             placeholder="HH:MM" />
                      <input *ngSwitchCase="12" 
                             type="text" 
                             class="param-input" 
                             [(ngModel)]="p.value"
                             placeholder="Valeur..." />
                      <input *ngSwitchCase="13" 
                             type="text" 
                             class="param-input" 
                             [(ngModel)]="p.value"
                             placeholder="Valeur..." />
                      <input *ngSwitchCase="14" 
                             type="text" 
                             class="param-input" 
                             [(ngModel)]="p.value"
                             placeholder="Valeur..." />
                      <input *ngSwitchDefault 
                             type="text" 
                             class="param-input" 
                             [(ngModel)]="p.value"
                             placeholder="Valeur..." />
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="selectedParamFilter === 'alert'">
              <tr *ngFor="let p of getFilteredParametres('alert')" class="parametrages-table-row">
                <td class="parametrages-table-cell font-semibold text-gray-600">{{ p.number }}</td>
                <td class="parametrages-table-cell font-medium text-gray-800">{{ p.name }}</td>
                <td class="parametrages-table-cell">
                  <div class="flex flex-col gap-2">
                    <select class="param-select"
                            [ngModel]="alertStates[p._id]?.active"
                            (ngModelChange)="onAlertStateChange(p, $event)">
                      <option [ngValue]="true">Activé</option>
                      <option [ngValue]="false">Désactivé</option>
                    </select>
                    <div *ngIf="p.number >= 15 && p.number <= 20 && alertStates[p._id]?.active && alertStates[p._id]?.message" 
                         class="alert-message-display">
                      <div class="alert-message-header">
                        <span class="material-symbols-outlined alert-message-icon">message</span>
                        <span class="alert-message-label">Message d'alerte</span>
                      </div>
                      <div class="alert-message-text">{{ alertStates[p._id].message }}</div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <div class="flex justify-center mt-6">
        <button 
          class="param-save-btn" 
          (click)="update()" 
          [disabled]="isLoading">
          <span *ngIf="!isLoading" class="flex items-center gap-2">
            <span class="material-symbols-outlined text-base">save</span>
            <span>Sauvegarder</span>
          </span>
          <span *ngIf="isLoading" class="flex items-center gap-2">
            <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            <span>Sauvegarde...</span>
          </span>
        </button>
      </div>
      
      <div class="alert-modal-overlay" *ngIf="showAlertModal">
        <div class="alert-modal" #alertModalContent>
          <div class="alert-modal-header">
            <h2 class="alert-modal-title">Message d'alerte</h2>
          </div>
          <div class="alert-modal-body">
            <div *ngIf="currentAlertParam" class="alert-modal-param-name">
              {{ currentAlertParam.name }}
            </div>
            <textarea
              class="alert-modal-textarea"
              rows="4"
              [(ngModel)]="alertMessageInput"
              placeholder="Saisissez le message d'alerte..."
            ></textarea>
          </div>
          <div class="alert-modal-footer">
            <button type="button"
                    class="alert-modal-btn alert-modal-btn-secondary"
                    (click)="closeAlertModal()"
                    [disabled]="isSavingAlert">
              Annuler
            </button>
            <button type="button"
                    class="alert-modal-btn alert-modal-btn-primary"
                    (click)="confirmAlertMessage()"
                    [disabled]="isSavingAlert">
              <span *ngIf="isSavingAlert" class="alert-modal-spinner"></span>
              <span>{{ isSavingAlert ? 'Enregistrement...' : 'Enregistrer' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
</div>
